export const SUPPORTED_LANGUAGES = ['id', 'en'] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const resources: Record<SupportedLanguage, any> = {
  id: {
    common: {
      dashboard: 'Dashboard',
      accounts: 'Akun',
      transactions: 'Transaksi',
      reports: 'Laporan',
      postingMonitor: 'Monitor Posting',
      accountingSetup: 'Setup Accounting',
      accountMappings: 'Mapping Akun',
      financeGuide: 'Panduan Finance',
      openingBalances: 'Saldo Awal',
      closingPeriods: 'Closing Period',
      entity: 'Entitas',
      branch: 'Cabang',
      allBranches: 'Semua Cabang',
      changePassword: 'Ubah Password',
      signOut: 'Keluar',
      login: 'Masuk',
      username: 'Username',
      password: 'Password',
      loading: 'Memuat...',
      confirm: 'Konfirmasi',
      year: 'Tahun',
      month: 'Bulan',
      scope: 'Ruang Lingkup',
      quickActions: 'Aksi Cepat',
      detail: 'Detail',
      source: 'Sumber',
      status: 'Status',
      amount: 'Nilai',
      date: 'Tanggal',
      search: 'Cari',
      label: 'Label',
      mode: 'Mode',
      txCountSuffix: 'transaksi',
      english: 'English',
      indonesian: 'Bahasa Indonesia',
      language: 'Bahasa',
    },
    nav: {
      accounting: 'Accounting',
      dashboard: 'Dashboard',
      accounts: 'Akun',
      transactions: 'Transaksi',
      reports: 'Laporan',
      postingMonitor: 'Monitor Posting',
      accountingSetup: 'Setup Accounting',
      accountMappings: 'Mapping Akun',
      financeGuide: 'Panduan Finance',
      openingBalances: 'Saldo Awal',
      closingPeriods: 'Closing Period',
    },
    login: {
      welcome: 'Selamat datang, masuk ke workspace accounting Anda',
      usernameRequired: 'Silakan isi username Anda',
      passwordRequired: 'Silakan isi password Anda',
    },
    organization: {
      activeScope: 'Scope aktif',
      allAccessibleBranches: 'Semua cabang yang dapat diakses',
    },
    dashboard: {
      eyebrow: 'Workspace Accounting',
      title: 'Dashboard Keuangan',
      subtitle:
        'Ringkasan ini membaca jurnal accounting yang terhubung ke sistem internal Anda. Scope saat ini mengikuti entitas dan cabang aktif di header.',
      period: 'Periode',
      ytd: 'YTD',
      monthlyRevenue: 'Pendapatan Bulan Ini',
      monthlyExpense: 'Beban Bulan Ini',
      runningProfit: 'Laba Rugi Berjalan',
      monthlyJournals: 'Jurnal Bulan Ini',
      financialSnapshot: 'Snapshot Keuangan',
      financialSnapshotDesc:
        'Gambaran cepat posisi periodik dari jurnal pada scope yang sedang aktif.',
      ytdAssets: 'Aset YTD',
      ytdLiabilities: 'Kewajiban YTD',
      ytdEquity: 'Ekuitas YTD',
      automatedJournals: 'Jurnal Otomatis',
      manualJournals: 'Jurnal Manual',
      postingOverview: 'Overview Posting',
      postingOverviewDesc:
        'Komposisi source transaksi accounting untuk bulan berjalan.',
      workspaceStatus: 'Status Workspace',
      workspaceStatusDesc:
        'Kontrol dasar untuk memastikan scope accounting Anda rapi sebelum masuk ke laporan.',
      accountGroups: 'Kelompok Akun',
      branchesInScope: 'Cabang dalam Scope',
      lastActivity: 'Aktivitas Terakhir',
      posted: 'Posted',
      draft: 'Draft',
      failedOrReversed: 'Failed / Reversed',
      recentFeed: 'Feed Jurnal Terbaru',
      recentFeedDesc:
        'Feed transaksi terbaru di bulan berjalan untuk scope aktif.',
      noFeed: 'Belum ada feed jurnal untuk ditampilkan pada periode ini.',
      accountingFocus: 'Fokus Accounting',
      accountingFocusDesc:
        'Ini area yang sebaiknya menjadi fokus pengembangan berikutnya agar accounting Anda benar-benar operasional.',
      postingMonitorMissing: 'monitor posting',
      accountMappingNext: 'mapping akun',
      branchAwareReady: 'dashboard ini',
      quickActionsDesc:
        'Shortcut supaya tim accounting tidak mulai dari chart of accounts.',
      nextPriority: 'prioritas berikutnya',
      branchEntityAware: 'sudah branch/entity aware',
      noTransactionsInPeriod:
        'Belum ada transaksi accounting di scope ini untuk periode berjalan.',
      createManualJournal: 'Buat jurnal manual',
      reviewRecentPostings: 'Tinjau posting terbaru',
      generateReports: 'Generate laporan',
      maintainCoa: 'Kelola chart of accounts',
      newJournal: 'Jurnal Baru',
      openTransactions: 'Buka Transaksi',
      openReports: 'Buka Laporan',
      openCoa: 'Buka COA',
      automated: 'Otomatis',
      manual: 'Manual',
      noDescription: 'Tidak ada deskripsi.',
    },
    postingMonitor: {
      title: 'Monitor Posting',
      desc:
        'Halaman ini dipakai untuk memantau jurnal otomatis dari sistem internal: penjualan, pembayaran, pembelian, dan expense. Fokusnya adalah cepat melihat transaksi yang draft, gagal, atau perlu ditelusuri per source.',
      automatedFeed: 'Feed Otomatis',
      automated: 'Otomatis',
      posted: 'Posted',
      draft: 'Draft',
      failed: 'Failed',
      reversed: 'Reversed',
      value: 'Nilai',
      totalAutomatedHint: 'Total jurnal otomatis di scope aktif',
      postedHint: 'Jurnal yang berhasil terposting',
      draftHint: 'Perlu review sebelum final',
      failedHint: 'Butuh investigasi posting',
      reversedHint: 'Jurnal yang sudah dibalik',
      valueHint: 'Nilai jurnal otomatis periode ini',
      sourceComposition: 'Komposisi Source',
      sourceCompositionDesc:
        'Distribusi source posting otomatis pada scope dan periode aktif.',
      monitorFeed: 'Feed Monitor',
      monitorFeedDesc:
        'Filter feed di bawah ini untuk menelusuri jurnal otomatis yang perlu dicek.',
      noAutomated: 'Belum ada transaksi otomatis di scope ini.',
      allSources: 'Semua Sumber',
      allStatuses: 'Semua Status',
      saleInvoice: 'Invoice Penjualan',
      salePayment: 'Pembayaran Penjualan',
      purchasePayment: 'Pembayaran Pembelian',
      expense: 'Expense',
      manual: 'Manual',
    },
    setup: {
      title: 'Setup Accounting',
      desc:
        'Halaman ini membantu tim finance memulai pembukuan dengan pendekatan yang umum dipakai bisnis saat transisi: tentukan tanggal cut-off, siapkan saldo awal, lalu mulai posting transaksi baru secara disiplin.',
      cutOffTitle: '1. Tentukan Tanggal Cut-off',
      cutOffDesc:
        'Pilih tanggal mulai pembukuan resmi. Setelah tanggal ini, jurnal transaksi harus masuk lewat sistem accounting yang baru.',
      openingTitle: '2. Siapkan Opening Balance',
      openingDesc:
        'Saldo awal cukup dimasukkan ringkas per entitas dan cabang, tanpa perlu memaksa input histori detail lama.',
      checklistTitle: '3. Checklist Go-Live',
      checklistDesc:
        'Langkah minimum agar transisi accounting tidak setengah jadi.',
      migrationTitle: 'Rekomendasi Migrasi',
      migrationDesc:
        'Untuk kondisi cabang yang sudah berjalan, metode yang paling aman biasanya adalah saldo awal + cut-off, bukan membangun ulang semua histori.',
      checklist: {
        entities: 'Buat entitas bisnis dan mapping cabang',
        coa: 'Pastikan chart of accounts dan subaccount inti siap',
        banks: 'Tentukan akun kas dan bank per cabang bila diperlukan',
        opening: 'Input saldo awal kas, bank, piutang, hutang, persediaan, modal',
        source: 'Validasi source posting: sale, payment, purchase, expense',
        monitor: 'Pantau jurnal otomatis lewat Posting Monitor setelah go-live',
      },
      openingItems: {
        cash: 'Kas / Bank',
        receivable: 'Piutang pelanggan',
        payable: 'Hutang supplier',
        inventory: 'Persediaan',
        fixedAsset: 'Aset tetap penting',
        equity: 'Modal / saldo awal / partner balance',
      },
      migrationBullets: {
        recommended: 'Mulai dari tanggal cut-off dan gunakan saldo awal untuk posisi sebelum tanggal tersebut.',
        avoid: 'Hindari memaksa input semua histori lama satu per satu kecuali memang ada kebutuhan audit khusus.',
        discipline: 'Setelah go-live, semua transaksi baru harus disiplin lewat alur yang sudah terhubung ke accounting.',
      },
    },
    accounts: {
      initTitle: 'Silakan inisialisasi akun accounting',
      initDesc:
        'Sistem akan membuat kelompok akun default yang dibutuhkan untuk mulai menjalankan accounting.',
      initButton: 'Inisialisasi Akun',
      totalData: 'Total Data',
      searchPlaceholder: 'Cari akun',
      createAccount: 'Buat Akun',
      createNewAccount: 'Buat Akun Baru',
      editAccount: 'Ubah Akun',
    },
    reportsPage: {
      title: 'Laporan Accounting',
      desc:
        'Generate laporan berdasarkan scope entitas/cabang aktif. Gunakan periode yang sudah bersih agar hasil laporan lebih mudah dipercaya.',
      periodTitle: 'Pilih Periode',
      periodDesc:
        'Anda bisa memakai range tanggal atau kombinasi bulan-tahun. Setelah confirm, laporan akan mengikuti scope aktif di header.',
      reportListTitle: 'Jenis Laporan',
      reportListDesc:
        'Mulai dari jurnal umum untuk audit detail, lalu laba rugi dan neraca untuk pembacaan manajemen.',
      scopeTitle: 'Scope Laporan',
      choosePeriod: 'Pilih periode',
      noData: 'Belum ada transaksi accounting pada periode dan scope ini.',
      journal: 'Jurnal Umum',
      income: 'Laba Rugi',
      balanceSheet: 'Neraca',
    },
    mappings: {
      totalMappings: 'Total Mapping',
      scopeEntity: 'Scope Entitas',
      scopeBranch: 'Scope Cabang',
      globalDefault: 'Default Global',
      createMapping: 'Buat Mapping',
      createNewMapping: 'Buat Mapping Baru',
      editMapping: 'Ubah Mapping',
      searchPlaceholder: 'Cari mapping',
    },
    openingBalance: {
      title: 'Input Saldo Awal',
      desc:
        'Saldo awal adalah snapshot posisi keuangan tepat sebelum tanggal cut-off. Setelah saldo awal dimasukkan, transaksi baru harus berjalan dari sistem internal dan dipantau lewat posting monitor.',
      safetyTitle: 'Yang Harus Dipastikan Dulu',
      readyTitle: 'Checklist Aman',
      dateLabel: 'Tanggal Cut-off',
      label: 'Label Jurnal',
      description: 'Keterangan',
      save: 'Simpan Saldo Awal',
      existingTitle: 'Saldo Awal Tersimpan',
      defaultLabel: 'Opening Balance',
      defaultDescription: 'Saldo awal untuk memulai pembukuan resmi setelah cut-off.',
      safety: {
        freezeOld: 'Pilih satu tanggal cut-off. Saldo awal mewakili posisi sebelum tanggal itu, bukan sesudahnya.',
        avoidDuplicate: 'Jangan input opening balance dua kali untuk entitas/cabang dan tanggal yang sama.',
        newFlowOnly: 'Setelah cut-off, transaksi baru harus masuk dari flow operasional biasa, bukan ditambah lagi manual sebagai saldo awal.',
      },
      ready: {
        cashBank: 'Pastikan kas dan bank sudah dihitung per cabang jika memang dipisah.',
        arAp: 'Pastikan piutang dan hutang outstanding sudah direkap.',
        inventory: 'Pastikan nilai persediaan di tanggal cut-off sudah ditentukan.',
        equity: 'Pastikan lawan saldo awal menggunakan akun modal atau ekuitas saldo awal yang benar.',
      },
    },
    periodLock: {
      title: 'Closing & Lock Period',
      desc:
        'Gunakan halaman ini untuk menutup periode yang sudah selesai. Setelah lock aktif, input jurnal manual dan saldo awal pada rentang itu akan ditolak backend.',
      createLock: 'Buat Lock Period',
      createNewLock: 'Buat Lock Baru',
      editLock: 'Ubah Lock',
      totalLocks: 'Total Lock Aktif',
      scopeTitle: 'Scope Lock',
      label: 'Label Lock',
      notes: 'Catatan',
      startDate: 'Tanggal Mulai',
      endDate: 'Tanggal Selesai',
      activeOnly: 'Hanya Aktif',
      allStatuses: 'Semua Status',
      active: 'Aktif',
      inactive: 'Nonaktif',
      searchPlaceholder: 'Cari lock period',
    },
    guide: {
      title: 'Panduan Pakai Accounting',
      desc:
        'Halaman ini menjelaskan cara memakai workspace accounting untuk tim yang belum terbiasa dengan akuntansi formal. Tujuannya supaya sistem ini tetap bisa dijalankan dengan disiplin walaupun pembukuan sebelumnya belum rapi.',
      whatTitle: 'Apa Fungsi Workspace Ini',
      whatDesc:
        'Accounting dipakai untuk membaca transaksi dari sistem internal, membuat jurnalnya, memantau posting otomatis, lalu menghasilkan laporan per entitas dan per cabang.',
      whoTitle: 'Siapa yang Pakai',
      notForTitle: 'Bukan untuk Apa',
      notForDesc:
        'Halaman ini bukan untuk input semua histori lama satu per satu. Untuk bisnis Anda, pendekatan yang lebih benar adalah cut-off + opening balance lalu transaksi baru masuk dengan rapi.',
      dailyTitle: 'Alur Harian yang Disarankan',
      dailyDesc:
        'Ini urutan paling sederhana untuk finance awam agar tidak bingung harus mulai dari mana.',
      closeTitle: 'Alur Closing Sederhana',
      closeDesc:
        'Menjelang akhir bulan, fokusnya adalah memastikan transaksi sudah masuk, mapping benar, dan tidak ada jurnal gagal yang tertinggal.',
      readyTitle: 'Kapan Sistem Ini Sudah Cukup Siap',
      readyDesc:
        'Untuk bisnis Anda, accounting sudah cukup layak dipakai harian kalau semua syarat minimum ini terpenuhi.',
      roles: {
        owner: 'Owner atau manajemen melihat dashboard, laporan, dan kesehatan posting.',
        financeAdmin: 'Finance admin memeriksa transaksi, monitor posting, mapping, dan laporan periodik.',
        branchAdmin: 'Admin cabang tetap fokus di operasional. Accounting mengambil data dari transaksi yang mereka input.',
      },
      daily: {
        checkScope: 'Pilih entitas dan cabang yang sedang ingin ditinjau di header.',
        monitorPostings: 'Buka Posting Monitor untuk melihat apakah jurnal otomatis hari ini ada yang draft, failed, atau reversed.',
        reviewTransactions: 'Buka Transactions untuk menelusuri jurnal yang perlu dicek lebih detail.',
        reporting: 'Buka Reports bila ingin melihat hasil keuangan untuk periode yang aktif.',
      },
      close: {
        reconcile: 'Pastikan transaksi operasional penting sudah masuk: penjualan, pembayaran, pembelian, dan expense.',
        reviewDraft: 'Selesaikan jurnal draft atau failed sebelum laporan dipakai.',
        fixMapping: 'Jika source tertentu masuk ke akun yang salah, perbaiki di Account Mapping, bukan dengan mengedit data sembarangan.',
        exportReports: 'Setelah data bersih, generate laporan per cabang atau per entitas.',
      },
      ready: {
        entitiesReady: 'Semua branch sudah terhubung ke entitas yang benar.',
        coaReady: 'Chart of accounts inti dan akun kas/bank cabang sudah tersedia.',
        mappingsReady: 'Mapping utama sale, sale payment, dan purchase payment sudah sesuai akun yang diinginkan.',
        openingReady: 'Opening balance sudah ditentukan untuk tanggal cut-off yang dipilih.',
        monitorStable: 'Posting Monitor tidak menunjukkan banyak jurnal gagal pada alur harian normal.',
      },
    },
  },
  en: {
    common: {
      dashboard: 'Dashboard',
      accounts: 'Accounts',
      transactions: 'Transactions',
      reports: 'Reports',
      postingMonitor: 'Posting Monitor',
      accountingSetup: 'Accounting Setup',
      accountMappings: 'Account Mapping',
      financeGuide: 'Finance Guide',
      openingBalances: 'Opening Balance',
      closingPeriods: 'Closing Period',
      entity: 'Entity',
      branch: 'Branch',
      allBranches: 'All Branches',
      changePassword: 'Change Password',
      signOut: 'Sign Out',
      login: 'Login',
      username: 'Username',
      password: 'Password',
      loading: 'Loading...',
      confirm: 'Confirm',
      year: 'Year',
      month: 'Month',
      scope: 'Scope',
      quickActions: 'Quick Actions',
      detail: 'Detail',
      source: 'Source',
      status: 'Status',
      amount: 'Amount',
      date: 'Date',
      search: 'Search',
      label: 'Label',
      mode: 'Mode',
      txCountSuffix: 'transactions',
      english: 'English',
      indonesian: 'Bahasa Indonesia',
      language: 'Language',
    },
    nav: {
      accounting: 'Accounting',
      dashboard: 'Dashboard',
      accounts: 'Accounts',
      transactions: 'Transactions',
      reports: 'Reports',
      postingMonitor: 'Posting Monitor',
      accountingSetup: 'Accounting Setup',
      accountMappings: 'Account Mapping',
      financeGuide: 'Finance Guide',
      openingBalances: 'Opening Balance',
      closingPeriods: 'Closing Period',
    },
    login: {
      welcome: 'Welcome, login to your accounting workspace',
      usernameRequired: 'Please input your username!',
      passwordRequired: 'Please input your password!',
    },
    organization: {
      activeScope: 'Active scope',
      allAccessibleBranches: 'All accessible branches',
    },
    dashboard: {
      eyebrow: 'Accounting Workspace',
      title: 'Financial Dashboard',
      subtitle:
        'This overview reads accounting journals connected to your internal system. The current scope follows the active entity and branch from the header.',
      period: 'Period',
      ytd: 'YTD',
      monthlyRevenue: 'Revenue This Month',
      monthlyExpense: 'Expense This Month',
      runningProfit: 'Running Profit / Loss',
      monthlyJournals: 'Journals This Month',
      financialSnapshot: 'Financial Snapshot',
      financialSnapshotDesc:
        'A quick periodic view of journal position for the current scope.',
      ytdAssets: 'Assets YTD',
      ytdLiabilities: 'Liabilities YTD',
      ytdEquity: 'Equity YTD',
      automatedJournals: 'Automated Journals',
      manualJournals: 'Manual Journals',
      postingOverview: 'Posting Overview',
      postingOverviewDesc:
        'Composition of accounting transaction sources for the current month.',
      workspaceStatus: 'Workspace Status',
      workspaceStatusDesc:
        'Basic controls to make sure your accounting scope is clean before reporting.',
      accountGroups: 'Account Groups',
      branchesInScope: 'Branches in Scope',
      lastActivity: 'Last Activity',
      posted: 'Posted',
      draft: 'Draft',
      failedOrReversed: 'Failed / Reversed',
      recentFeed: 'Recent Journal Feed',
      recentFeedDesc:
        'Recent transactions during the current month for the active scope.',
      noFeed: 'No journal feed is available for this period yet.',
      accountingFocus: 'Accounting Focus',
      accountingFocusDesc:
        'These are the next areas worth improving so the accounting app becomes truly operational.',
      postingMonitorMissing: 'posting monitor',
      accountMappingNext: 'account mapping',
      branchAwareReady: 'this dashboard',
      quickActionsDesc:
        'Shortcuts so the accounting team does not have to start from the chart of accounts.',
      nextPriority: 'next priority',
      branchEntityAware: 'already branch/entity aware',
      noTransactionsInPeriod:
        'No accounting transactions are available for this scope during the current period.',
      createManualJournal: 'Create manual journal',
      reviewRecentPostings: 'Review recent postings',
      generateReports: 'Generate reports',
      maintainCoa: 'Maintain chart of accounts',
      newJournal: 'New Journal',
      openTransactions: 'Open Transactions',
      openReports: 'Open Reports',
      openCoa: 'Open COA',
      automated: 'Automated',
      manual: 'Manual',
      noDescription: 'No description provided.',
    },
    postingMonitor: {
      title: 'Posting Monitor',
      desc:
        'Use this page to monitor automated journals from your internal system: sales, payments, purchases, and expenses. The main goal is to quickly spot draft, failed, or source-specific posting issues.',
      automatedFeed: 'Automated Feed',
      automated: 'Automated',
      posted: 'Posted',
      draft: 'Draft',
      failed: 'Failed',
      reversed: 'Reversed',
      value: 'Value',
      totalAutomatedHint: 'Total automated journals in the active scope',
      postedHint: 'Journals successfully posted',
      draftHint: 'Need review before finalizing',
      failedHint: 'Need posting investigation',
      reversedHint: 'Journals already reversed',
      valueHint: 'Automated journal value for this period',
      sourceComposition: 'Source Composition',
      sourceCompositionDesc:
        'Distribution of automated posting sources for the active scope and period.',
      monitorFeed: 'Monitor Feed',
      monitorFeedDesc:
        'Use the filters below to inspect automated journals that need attention.',
      noAutomated: 'No automated transactions are available in this scope yet.',
      allSources: 'All Sources',
      allStatuses: 'All Statuses',
      saleInvoice: 'Sale Invoice',
      salePayment: 'Sale Payment',
      purchasePayment: 'Purchase Payment',
      expense: 'Expense',
      manual: 'Manual',
    },
    setup: {
      title: 'Accounting Setup',
      desc:
        'This page helps finance users start bookkeeping using the standard business transition approach: define the cut-off date, prepare opening balances, then enforce new transactions through the new accounting flow.',
      cutOffTitle: '1. Define Cut-off Date',
      cutOffDesc:
        'Choose the official bookkeeping start date. After this date, all journals should flow through the new accounting system.',
      openingTitle: '2. Prepare Opening Balance',
      openingDesc:
        'Opening balances can be entered in a summarized form per entity and branch, without forcing a full historical rebuild.',
      checklistTitle: '3. Go-Live Checklist',
      checklistDesc:
        'The minimum actions required so the accounting transition does not remain half done.',
      migrationTitle: 'Migration Recommendation',
      migrationDesc:
        'For branches that are already running, the safest approach is usually opening balance + cut-off, not rebuilding every old historical journal.',
      checklist: {
        entities: 'Create business entities and assign branches correctly',
        coa: 'Make sure core chart of accounts and subaccounts are ready',
        banks: 'Define cash and bank accounts per branch where needed',
        opening: 'Input opening balances for cash, bank, receivable, payable, inventory, and equity',
        source: 'Validate posting sources: sale, payment, purchase, expense',
        monitor: 'Monitor automated journals through Posting Monitor after go-live',
      },
      openingItems: {
        cash: 'Cash / Bank',
        receivable: 'Customer receivables',
        payable: 'Supplier payables',
        inventory: 'Inventory',
        fixedAsset: 'Key fixed assets',
        equity: 'Capital / opening balance / partner balance',
      },
      migrationBullets: {
        recommended: 'Start from the cut-off date and use opening balances for positions before that date.',
        avoid: 'Avoid forcing all old history into detailed journals unless you truly need it for audit reasons.',
        discipline: 'After go-live, all new transactions should consistently pass through the connected accounting flow.',
      },
    },
    accounts: {
      initTitle: 'Please initialize accounting accounts',
      initDesc:
        'The system will create the default account groups required to start using accounting.',
      initButton: 'Initialize Accounts',
      totalData: 'Total Data',
      searchPlaceholder: 'Search account',
      createAccount: 'Create Account',
      createNewAccount: 'Create New Account',
      editAccount: 'Edit Account',
    },
    reportsPage: {
      title: 'Accounting Reports',
      desc:
        'Generate reports based on the active entity/branch scope. Use a clean period so the report is easier to trust.',
      periodTitle: 'Choose Period',
      periodDesc:
        'You can use a date range or a month-year combination. After confirmation, reports will follow the active scope from the header.',
      reportListTitle: 'Report Types',
      reportListDesc:
        'Start with the general journal for detailed audit, then income statement and balance sheet for management review.',
      scopeTitle: 'Report Scope',
      choosePeriod: 'Choose period',
      noData: 'No accounting transactions exist for this scope and period yet.',
      journal: 'General Journal',
      income: 'Income Statement',
      balanceSheet: 'Balance Sheet',
    },
    mappings: {
      totalMappings: 'Total Mappings',
      scopeEntity: 'Entity Scope',
      scopeBranch: 'Branch Scope',
      globalDefault: 'Global Default',
      createMapping: 'Create Mapping',
      createNewMapping: 'Create New Mapping',
      editMapping: 'Edit Mapping',
      searchPlaceholder: 'Search mapping',
    },
    openingBalance: {
      title: 'Opening Balance Entry',
      desc:
        'Opening balance is a snapshot of your financial position right before the cut-off date. After it is posted, new transactions should continue through the internal system and be monitored through Posting Monitor.',
      safetyTitle: 'What Must Be Confirmed First',
      readyTitle: 'Safety Checklist',
      dateLabel: 'Cut-off Date',
      label: 'Journal Label',
      description: 'Description',
      save: 'Save Opening Balance',
      existingTitle: 'Saved Opening Balances',
      defaultLabel: 'Opening Balance',
      defaultDescription: 'Opening balance used to start formal bookkeeping after cut-off.',
      safety: {
        freezeOld: 'Choose one cut-off date. Opening balance represents the position before that date, not after it.',
        avoidDuplicate: 'Do not enter opening balance twice for the same entity/branch and date.',
        newFlowOnly: 'After cut-off, new transactions should come through the normal operational flow, not be added again manually as opening balance.',
      },
      ready: {
        cashBank: 'Make sure cash and bank balances are counted per branch if they are separated.',
        arAp: 'Make sure outstanding receivables and payables are summarized.',
        inventory: 'Make sure inventory value on the cut-off date is determined.',
        equity: 'Make sure the balancing side uses the correct capital or opening equity account.',
      },
    },
    periodLock: {
      title: 'Closing & Lock Period',
      desc:
        'Use this page to close completed periods. Once a lock is active, backend will reject manual journals and opening balance entries inside that range.',
      createLock: 'Create Period Lock',
      createNewLock: 'Create New Lock',
      editLock: 'Edit Lock',
      totalLocks: 'Total Active Locks',
      scopeTitle: 'Lock Scope',
      label: 'Lock Label',
      notes: 'Notes',
      startDate: 'Start Date',
      endDate: 'End Date',
      activeOnly: 'Active Only',
      allStatuses: 'All Statuses',
      active: 'Active',
      inactive: 'Inactive',
      searchPlaceholder: 'Search period lock',
    },
    guide: {
      title: 'Accounting Usage Guide',
      desc:
        'This page explains how to use the accounting workspace for teams that are not yet comfortable with formal accounting. The goal is to keep the system usable with discipline even if previous bookkeeping was messy.',
      whatTitle: 'What This Workspace Does',
      whatDesc:
        'Accounting is used to read transactions from the internal system, generate journals, monitor automated posting, and produce reports by entity and branch.',
      whoTitle: 'Who Uses It',
      notForTitle: 'What It Is Not For',
      notForDesc:
        'This workspace is not meant for manually recreating all old historical journals one by one. For your business, the better approach is cut-off + opening balance, then clean posting for new transactions.',
      dailyTitle: 'Recommended Daily Flow',
      dailyDesc:
        'This is the simplest operating order for non-expert finance users so they do not get confused about where to start.',
      closeTitle: 'Simple Closing Flow',
      closeDesc:
        'Near month-end, the focus should be on making sure transactions are recorded, mappings are correct, and no failed journals are left behind.',
      readyTitle: 'When This System Is Ready Enough',
      readyDesc:
        'For your business, accounting is ready enough for daily use once these minimum conditions are met.',
      roles: {
        owner: 'Owners or management review dashboards, reports, and posting health.',
        financeAdmin: 'Finance admins review transactions, posting monitor, mappings, and periodic reports.',
        branchAdmin: 'Branch admins stay focused on operations. Accounting reads the transactions they input.',
      },
      daily: {
        checkScope: 'Select the entity and branch you want to review from the header.',
        monitorPostings: 'Open Posting Monitor to see whether today’s automated journals are draft, failed, or reversed.',
        reviewTransactions: 'Open Transactions to inspect journals that need more detailed review.',
        reporting: 'Open Reports when you want to view the financial result for the active period.',
      },
      close: {
        reconcile: 'Make sure important operational transactions are present: sales, payments, purchases, and expenses.',
        reviewDraft: 'Resolve draft or failed journals before relying on reports.',
        fixMapping: 'If a source posts to the wrong account, fix it in Account Mapping instead of editing data randomly.',
        exportReports: 'Once the data is clean, generate reports by branch or by entity.',
      },
      ready: {
        entitiesReady: 'All branches are linked to the correct entities.',
        coaReady: 'The core chart of accounts and branch cash/bank accounts are available.',
        mappingsReady: 'Core mappings for sale, sale payment, and purchase payment are already aligned to the intended accounts.',
        openingReady: 'Opening balances are prepared for the selected cut-off date.',
        monitorStable: 'Posting Monitor does not show many failed journals during normal daily use.',
      },
    },
  },
}
